import { render, staticRenderFns } from "./ChangeActivationKey.vue?vue&type=template&id=235b13e4"
import script from "./ChangeActivationKey.vue?vue&type=script&lang=ts"
export * from "./ChangeActivationKey.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports